import { Component } from '@angular/core';
import { BannerAppComponent } from '../../../components/banner-app/banner-app.component';
import { FooterAppComponent } from '../../../components/footer-app/footer-app.component';

@Component({
  selector: 'sura-sarlaft-denied',
  standalone: true,
  imports: [BannerAppComponent, FooterAppComponent],
  templateUrl: './sarlaft-denied.component.html',
  styleUrl: './sarlaft-denied.component.scss',
})
export class SarlaftDeniedComponent {
  redirect() {
    window.location.href = 'https://www.sura.co/';
  }
}
